export default __webpack_public_path__ + "media/images/mailer/icon_lock_open-5b803c6e7f70e6335fb1cb78ed920777.png";